import { render, staticRenderFns } from "./FollowupsSwitch.vue?vue&type=template&id=1e8395ae&scoped=true"
import script from "./FollowupsSwitch.vue?vue&type=script&lang=js"
export * from "./FollowupsSwitch.vue?vue&type=script&lang=js"
import style0 from "./FollowupsSwitch.vue?vue&type=style&index=0&id=1e8395ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8395ae",
  null
  
)

export default component.exports